export function escapeHtml(value: string): string {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;')
}

export function isSafeRichUrl(value: string): boolean {
  const url = value.trim()
  if (!url || /[\u0000-\u001f\u007f]/.test(url)) return false
  return !/^(?:javascript|vbscript|data):/i.test(url)
}

export function userProfileHtml(userId: string): string {
  const id = userId.trim().replace(/[^a-zA-Z0-9_.:-]/g, '').slice(0, 80)
  const safe = escapeHtml(id)
  return `<div desk_el="rich_el" data-kind="user-profile"><user-profile user-id="${safe}">User #${safe}</user-profile></div>`
}

export function accordionHtml(sectionsCount = 3): string {
  const count = Math.max(1, Math.min(10, Math.trunc(sectionsCount) || 1))
  const sections = Array.from({ length: count }, (_, index) => {
    const number = index + 1
    const open = index === 0 ? ' open=""' : ''
    return `<accordion-section title="Section ${number}"${open}><p>Section ${number} content.</p></accordion-section>`
  }).join('')
  return `<div desk_el="rich_el" data-kind="ui-accordion"><ui-accordion>${sections}</ui-accordion></div>`
}

export type CalloutTone = 'info' | 'success' | 'warning' | 'danger'

export function messageCalloutHtml(tone: CalloutTone = 'info', title = 'Important note', content = 'Add the callout content here.'): string {
  const safeTone = /^(?:info|success|warning|danger)$/.test(tone) ? tone : 'info'
  return `<div desk_el="rich_el" data-kind="message-callout"><message-callout tone="${safeTone}" title="${escapeHtml(title.slice(0, 160))}"><p>${escapeHtml(content)}</p></message-callout></div>`
}

export function progressMeterHtml(value = 65, max = 100, label = 'Progress'): string {
  const safeMax = Math.max(1, Math.min(1_000_000, Number.isFinite(max) ? max : 100))
  const safeValue = Math.max(0, Math.min(safeMax, Number.isFinite(value) ? value : 0))
  const safeLabel = escapeHtml(label.slice(0, 160))
  return `<div desk_el="rich_el" data-kind="progress-meter"><progress-meter label="${safeLabel}" value="${safeValue}" max="${safeMax}">${safeLabel}: ${safeValue} / ${safeMax}</progress-meter></div>`
}

export function contentTabsHtml(tabsCount = 3): string {
  const count = Math.max(2, Math.min(6, Math.trunc(tabsCount) || 2))
  const tabs = Array.from({ length: count }, (_, index) => {
    const number = index + 1
    const active = index === 0 ? ' active=""' : ''
    return `<content-tab title="Tab ${number}"${active}><p>Tab ${number} content.</p></content-tab>`
  }).join('')
  return `<div desk_el="rich_el" data-kind="content-tabs"><content-tabs>${tabs}</content-tabs></div>`
}

export function currentTimeHtml(): string {
  return '<div desk_el="rich_el" data-kind="current-time"><current-time>Current time</current-time></div>'
}

export function contentRevealHtml(contentHtml: string, label = 'Hidden text - click to reveal'): string {
  const safeLabel = escapeHtml(label.trim().slice(0, 160) || 'Hidden text - click to reveal')
  const content = contentHtml.trim() ? contentHtml : '<p>Hidden text</p>'
  return '<div desk_el="rich_el" data-kind="content-reveal">'
    + '<details style="margin:12px 0">'
    + `<summary style="cursor:pointer;padding:10px 12px;background-color:#d1d5db;color:#374151;border:1px solid #9ca3af;border-radius:6px;font-weight:600">${safeLabel}</summary>`
    + `<div style="padding:12px;background-color:#f3f4f6;border:1px solid #d1d5db;border-radius:0 0 6px 6px">${content}</div>`
    + '</details>'
    + '</div>'
}

export function tableHtml(rows = 2, columns = 2): string {
  const safeRows = Math.max(1, Math.min(10, Math.trunc(rows)))
  const safeColumns = Math.max(1, Math.min(10, Math.trunc(columns)))
  const cells = Array.from({ length: safeColumns }, () => '<td><br></td>').join('')
  return `<table border="1"><tbody>${Array.from({ length: safeRows }, () => `<tr>${cells}</tr>`).join('')}</tbody></table>`
}
